import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'audit-pdf-dialog',
  templateUrl: './t_pdf-dialog.component.html',
  styleUrls: ['./pdf-dialog.component.less']
})
export class PdfDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PdfDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  choose(choice)
  {
  	this.dialogRef.close(choice);
  }

}
